import { MicrosoftVisualStudioCodeIcon } from './MicrosoftVisualStudioCodeIcon';

/**
 * author: Contributors
 * id 6D1D5836-B731-41C4-A829-86E5741A0784
 * name microsoft-visual-studio-code
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-visual-studio-code.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const VsCodeIcon = MicrosoftVisualStudioCodeIcon;
export default VsCodeIcon